import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {FillableFormField} from './fillable-form-field.model';
import * as FillableFormFieldActions from './fillable-form-field.actions';

export const fillableFormFieldsFeatureKey = 'fillableFormFields';

export interface State extends EntityState<FillableFormField> {
  // additional entities state properties
}

export const adapter: EntityAdapter<FillableFormField> = createEntityAdapter<FillableFormField>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(FillableFormFieldActions.addFillableFormField,
    (state, action) => adapter.addOne(action.fillableFormField, state)
  ),
  on(FillableFormFieldActions.upsertFillableFormField,
    (state, action) => adapter.upsertOne(action.fillableFormField, state)
  ),
  on(FillableFormFieldActions.addFillableFormFields,
    (state, action) => adapter.addMany(action.fillableFormFields, state)
  ),
  on(FillableFormFieldActions.upsertFillableFormFields,
    (state, action) => adapter.upsertMany(action.fillableFormFields, state)
  ),
  on(FillableFormFieldActions.updateFillableFormField,
    (state, action) => adapter.updateOne(action.fillableFormField, state)
  ),
  on(FillableFormFieldActions.updateFillableFormFields,
    (state, action) => adapter.updateMany(action.fillableFormFields, state)
  ),
  on(FillableFormFieldActions.deleteFillableFormField,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(FillableFormFieldActions.deleteFillableFormFields,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(FillableFormFieldActions.loadFillableFormFields,
    (state, action) => adapter.setAll(action.fillableFormFields, state)
  ),
  on(FillableFormFieldActions.clearFillableFormFields,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
